import { pb } from './pocketbase';

// Récupérer une convention par son code IDCC
export const getIdccLabel = async (idccCode) => {
    try {
        // Vérifier si l'utilisateur est authentifié
        if (!pb.authStore.isValid) {
            return null;
        }

        const records = await pb.collection('conventions').getFullList({
            filter: `idcc = "${idccCode}"`
        });
        
        if (records && records.length > 0) {
            return records[0]; // Retourner le premier résultat trouvé
        }
        
        return null; // Aucune convention trouvée pour ce code IDCC
    } catch (error) {
        // Si erreur d'authentification, retourner null au lieu de throw
        if (error.status === 401 || error.status === 403) {
            return null;
        }
        
        throw error;
    }
};
